// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 1350px) {\n  .sundayWrapper {\n    margin-bottom: 4px;\n  }\n}", ""]);
// Exports
module.exports = exports;
